module.exports = __webpack_public_path__ + "static/media/HelveticaNeueLTPro-It.ac719c54.otf";